import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SpecialHoursStatus, TimeOfDayInterface } from '@vendasta/listing-products';
import {
  SpecialHoursDateTimeInterface,
  SpecialHoursTimeSpanInterface,
} from '../../special-hours/business-hours.interface';
import { getNewTimeOfDay, googleDateToNativeDate, nativeUTCDateToGoogleDate } from '../../business-hours';

const DefaultHoursPeriod: SpecialHoursTimeSpanInterface = {
  startTime: getNewTimeOfDay({ hours: 9, minutes: 0, seconds: 0, nanos: 0 } as TimeOfDayInterface),
  endTime: getNewTimeOfDay({ hours: 10, minutes: 0, seconds: 0, nanos: 0 } as TimeOfDayInterface),
};

@Component({
  selector: 'forms-edit-special-time-period',
  templateUrl: './edit-special-time-period.component.html',
  styleUrls: ['./edit-special-time-period.component.scss'],
})
export class EditSpecialTimePeriodComponent implements OnInit {
  @Input() dateWithHours: SpecialHoursDateTimeInterface;
  _timePeriod: SpecialHoursTimeSpanInterface[] = [];

  isOpen = false;
  selectedDate!: Date;

  @Output() dateValueChange = new EventEmitter();
  @Output() hoursValueChange = new EventEmitter();
  @Output() removeDate = new EventEmitter<void>();

  ngOnInit(): void {
    this.isOpen = this.getIsOpen(this.dateWithHours.status);
    this.selectedDate = googleDateToNativeDate(this.dateWithHours.date);
    this._timePeriod = [].concat(this.dateWithHours.timeSpan || []);
  }

  getIsOpen(status: SpecialHoursStatus): boolean {
    return status === SpecialHoursStatus.SPECIAL_HOURS_STATUS_OPEN;
  }

  onDateChange(value: Date): void {
    const googleDate = nativeUTCDateToGoogleDate(value.getUTCDate(), value.getUTCMonth(), value.getUTCFullYear());
    this.dateValueChange.emit(googleDate);
  }

  getStatus(isOpen: boolean): SpecialHoursStatus {
    return isOpen ? SpecialHoursStatus.SPECIAL_HOURS_STATUS_OPEN : SpecialHoursStatus.SPECIAL_HOURS_STATUS_CLOSED;
  }

  addHours(): void {
    this.isOpen = true;
    this.dateWithHours.status = SpecialHoursStatus.SPECIAL_HOURS_STATUS_OPEN;
    if (!this._timePeriod) {
      this._timePeriod = [] as SpecialHoursTimeSpanInterface[];
    }

    this._timePeriod.push(Object.assign({}, DefaultHoursPeriod) as SpecialHoursTimeSpanInterface);
  }

  changeHours(hours: SpecialHoursTimeSpanInterface, i: number): void {
    this._timePeriod[i] = hours;
    this.hoursValueChange.emit(this._timePeriod);
  }

  removeHours(index: number): void {
    this._timePeriod.splice(index, 1);
  }

  toggleIsOpen(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.dateWithHours.status = SpecialHoursStatus.SPECIAL_HOURS_STATUS_OPEN;
      this._timePeriod = [Object.assign({}, DefaultHoursPeriod) as SpecialHoursTimeSpanInterface];
    } else {
      this.dateWithHours.status = SpecialHoursStatus.SPECIAL_HOURS_STATUS_CLOSED;
      this._timePeriod = [] as SpecialHoursTimeSpanInterface[];
    }
    this.hoursValueChange.emit(this._timePeriod);
  }

  deleteDate(): void {
    this.removeDate.next();
  }
}
